import { render, staticRenderFns } from "./TournamentEditMain.vue?vue&type=template&id=d4c0daae&scoped=true"
import script from "./TournamentEditMain.vue?vue&type=script&lang=js"
export * from "./TournamentEditMain.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditMain.vue?vue&type=style&index=0&id=d4c0daae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c0daae",
  null
  
)

export default component.exports